export const FONT_OPTIONS = [
    {
        value: {
            name: 'Arial',
            fontFamily: 'Arial, Helvetica, sans-serif',
        },
        label: 'Arial',
    },
    {
        value: {
            name: 'Arial Black',
            fontFamily: "'Arial Black', 'Arial Bold', Arial, sans-serif",
        },
        label: 'Arial Black',
    },
    {
        value: {
            name: 'Tahoma',
            fontFamily: 'Tahoma, Geneva, sans-serif',
        },
        label: 'Tahoma',
    },
    {
        value: {
            name: 'Trebuchet MS',
            fontFamily: "'Trebuchet MS', Arial, sans-serif",
        },
        label: 'Trebuchet MS',
    },
    {
        value: {
            name: 'Verdana',
            fontFamily: 'Verdana, Arial, sans-serif',
        },
        label: 'Verdana',
    },
    {
        value: {
            name: 'Courier',
            fontFamily: "Courier, 'Courier New', monospace",
        },
        label: 'Courier',
    },
    {
        value: {
            name: 'Courier New',
            fontFamily: "'Courier New', Courier, monospace",
        },
        label: 'Courier New',
    },
    {
        value: {
            name: 'Georgia',
            fontFamily: "Georgia, 'Times New Roman', serif",
        },
        label: 'Georgia',
    },
    {
        value: {
            name: 'Times',
            fontFamily: 'Times, Georgia, serif',
        },
        label: 'Times',
    },
    {
        value: {
            name: 'Times New Roman',
            fontFamily: "'Times New Roman', Times, serif",
        },
        label: 'Times New Roman',
    },
    {
        value: {
            name: 'Inconsolata',
            fontFamily: "'Inconsolata', Courier New, monospace",
        },
        label: 'Inconsolata',
    },
    {
        value: {
            name: 'Dancing Script',
            fontFamily: "'Dancing Script', Times New Roman, cursive",
        },
        label: 'Dancing Script',
    },
    {
        value: {
            name: 'Playfair Display',
            fontFamily: "'Playfair Display', Georgia, serif",
        },
        label: 'Playfair Display',
    },
    {
        value: {
            name: 'Nunito',
            fontFamily: "'Nunito', Arial, sans-serif",
        },
        label: 'Nunito',
    },
    {
        value: {
            name: 'Oswald',
            fontFamily: "'Oswald', Impact, sans-serif",
        },
        label: 'Oswald',
    },
    {
        value: {
            name: 'Poppins',
            fontFamily: "'Poppins', Verdana, sans-serif",
        },
        label: 'Poppins',
    },
    {
        value: {
            name: 'Rubik',
            fontFamily: "'Rubik', Arial, sans-serif",
        },
        label: 'Rubik',
    },
    {
        value: {
            name: 'Source Sans Pro',
            fontFamily: "'Source Sans Pro', Trebuchet MS, sans-serif",
        },
        label: 'Source Sans Pro',
    },
    {
        value: {
            name: 'Source Serif Pro',
            fontFamily: "'Source Serif Pro', Georgia, serif",
        },
        label: 'Source Serif Pro',
    },
    {
        value: {
            name: 'Vollkorn',
            fontFamily: "'Vollkorn', Georgia, serif",
        },
        label: 'Vollkorn',
    },
    {
        value: {
            name: 'Arvo',
            fontFamily: "'Arvo', Verdana, serif",
        },
        label: 'Arvo',
    },
    {
        value: {
            name: 'Cabin',
            fontFamily: "'Cabin', Arial, sans-serif",
        },
        label: 'Cabin',
    },
    {
        value: {
            name: 'Montserrat',
            fontFamily: "'Montserrat', Verdana, sans-serif",
        },
        label: 'Montserrat',
    },
    {
        value: {
            name: 'Merriweather',
            fontFamily: "'Merriweather', Georgia, serif",
        },
        label: 'Merriweather',
    },
    {
        value: {
            name: 'Lora',
            fontFamily: "'Lora', Georgia, serif",
        },
        label: 'Lora',
    },
    {
        value: {
            name: 'Abril Fatface',
            fontFamily: "'Abril Fatface', Georgia, serif",
        },
        label: 'Abril Fatface',
    },
] as const;
